;(function () {
  const modal = document.getElementById('recharge-upsell-modal')
  if (!modal) {
    console.warn(
      '[recharge-upsell] modal element not found — snippet may not be rendering',
    )
    return
  }

  const FOUR_WEEKS = 4
  const TWELVE_WEEKS = 12

  function getSellingPlans() {
    try {
      return JSON.parse(modal.dataset.sellingPlans || '[]')
    } catch (e) {
      return []
    }
  }

  function findPlanById(id) {
    const groups = getSellingPlans()
    for (const group of groups) {
      for (const plan of group.selling_plans) {
        if (String(plan.id) === String(id)) return plan
      }
    }
    return null
  }

  function findPlansByName(keyword) {
    const matches = []
    for (const group of getSellingPlans()) {
      for (const plan of group.selling_plans) {
        if (plan.name.toLowerCase().includes(keyword.toLowerCase()))
          matches.push(plan)
      }
    }
    return matches
  }

  /**
   * Visit every element inside the Recharge widget, descending through the
   * nested shadow roots its components render into.
   */
  function walkWidget(callback) {
    const widget = document.querySelector('recharge-subscription-widget')
    if (!widget) return
    const queue = [widget]
    const visited = new Set()
    while (queue.length) {
      const node = queue.shift()
      if (!node || visited.has(node)) continue
      visited.add(node)
      callback(node)
      if (node.shadowRoot) queue.push(...node.shadowRoot.children)
      if (node.children) queue.push(...node.children)
    }
  }

  /**
   * The widget's own plan list is the only trustworthy source of selling plan
   * IDs. A product can be attached to several selling plan groups that share a
   * frequency — the product's own subscription plan and a shared bundle plan
   * both surface as "Every 12 weeks" in `product.selling_plan_groups` — so
   * matching on plan name picks whichever happens to come first and can hand
   * the bundle plan to add.js. Recharge's `external_plan_id` is the Shopify
   * selling plan ID, and the widget only lists the plans that belong to this
   * product's subscription.
   */
  function getWidgetPlans() {
    const plans = []
    const seen = new Set()
    walkWidget(function (node) {
      if (!Array.isArray(node.sellingPlans)) return
      node.sellingPlans.forEach(function (plan) {
        const id = plan && plan.external_plan_id
        if (!id || seen.has(String(id))) return
        seen.add(String(id))
        plans.push({
          id: String(id),
          frequency: Number(plan.order_interval_frequency),
          unit: String(plan.interval_unit || '').toLowerCase(),
          title: String(plan.title || ''),
          type: String(plan.type || ''),
        })
      })
    })
    return plans
  }

  function findWidgetPlanByWeeks(weeks) {
    const plans = getWidgetPlans()
    const byInterval = plans.filter(function (plan) {
      return plan.unit === 'week' && plan.frequency === weeks
    })
    const match =
      byInterval.find(function (plan) {
        return plan.type === 'subscription'
      }) || byInterval[0]
    if (match) return match.id

    const byTitle = plans.find(function (plan) {
      return plan.title.toLowerCase().includes(weeks + ' week')
    })
    return byTitle ? byTitle.id : null
  }

  /**
   * Fallback for when the widget's plan data can't be read: the rendered
   * frequency options carry the same Shopify selling plan IDs as their values.
   */
  function findWidgetOptionByWeeks(weeks) {
    const keyword = weeks + ' week'
    let found = null
    walkWidget(function (node) {
      if (found) return
      if (node.tagName !== 'OPTION' && node.tagName !== 'INPUT') return
      const value = String(node.value || '')
      if (!/^\d+$/.test(value)) return
      const label = (node.textContent || node.getAttribute('aria-label') || '')
        .toLowerCase()
      if (label.includes(keyword)) found = value
    })
    return found
  }

  /**
   * Last resort — the product's raw selling plan data. Only usable when the
   * frequency maps to a single plan; if the product carries both a
   * subscription and a bundle plan at this frequency there is nothing in the
   * Liquid data to tell them apart, so bail rather than risk the wrong one.
   */
  function findProductPlanByWeeks(weeks) {
    const matches = findPlansByName(weeks + ' week')
    return matches.length === 1 ? String(matches[0].id) : null
  }

  /**
   * When the custom PDP subscription options replace the Recharge widget,
   * their radios carry the active plan IDs (see pdp-subscription-options.js).
   */
  function findCustomOptionPlanByWeeks(weeks) {
    const radio = document.querySelector(
      '[data-js-subscription-radio][data-interval-weeks="' + weeks + '"]',
    )
    return radio && radio.dataset.planId ? radio.dataset.planId : null
  }

  function findTwelveWeekPlanId() {
    return (
      findCustomOptionPlanByWeeks(TWELVE_WEEKS) ||
      findWidgetPlanByWeeks(TWELVE_WEEKS) ||
      findWidgetOptionByWeeks(TWELVE_WEEKS) ||
      findProductPlanByWeeks(TWELVE_WEEKS)
    )
  }

  function refreshCart() {
    return fetch('?section_id=helper-cart')
      .then(function (r) {
        return r.text()
      })
      .then(function (text) {
        const dom = new DOMParser().parseFromString(text, 'text/html')
        const cartForm = document.getElementById('AjaxCartForm')
        const cartSubtotal = document.getElementById('AjaxCartSubtotal')
        if (cartForm) {
          cartForm.innerHTML = dom.getElementById('AjaxCartForm').innerHTML
          if (typeof cartForm.ajaxifyCartItems === 'function')
            cartForm.ajaxifyCartItems()
        }
        if (cartSubtotal) {
          cartSubtotal.innerHTML =
            dom.getElementById('AjaxCartSubtotal').innerHTML
        }
        document
          .querySelectorAll('[data-header-cart-count]')
          .forEach(function (el) {
            const countEl = document.querySelector(
              '#AjaxCartForm [data-cart-count]',
            )
            if (countEl) el.textContent = countEl.textContent
          })
        const productForm = document.querySelector('product-form')
        if (productForm) productForm.dispatchEvent(new Event('add-to-cart'))
      })
  }

  function addToCart(variantId, quantity, sellingPlanId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity,
        selling_plan: Number(sellingPlanId),
        properties: properties,
      }),
    }).then(function (r) {
      return r.json()
    })
  }

  /**
   * Returns the selected selling plan ID when the shopper has a 4-week
   * subscription selected, otherwise null. The widget keeps a hidden
   * `selling_plan` input in the product form in sync with its own selection,
   * which is the same value a normal add to cart would submit.
   */
  function detectFourWeekPlanId(form) {
    const widgetPlans = getWidgetPlans()

    function isFourWeek(planId) {
      const widgetPlan = widgetPlans.find(function (plan) {
        return plan.id === String(planId)
      })
      if (widgetPlan)
        return widgetPlan.unit === 'week' && widgetPlan.frequency === FOUR_WEEKS
      const plan = findPlanById(planId)
      return !!plan && plan.name.toLowerCase().includes('4 week')
    }

    const input = form.querySelector('[name="selling_plan"]')
    if (input && input.value) return isFourWeek(input.value) ? input.value : null

    const selected = findWidgetOptionByWeeks(FOUR_WEEKS)
    return selected && isFourWeek(selected) ? selected : null
  }

  document.addEventListener('click', function (e) {
    const atcButton = e.target.closest('[data-main-product-add-to-cart]')
    if (!atcButton) return

    const productForm = atcButton.closest('product-form')
    if (!productForm) return
    const form = productForm.querySelector('form')
    if (!form) return

    const fourWeekPlanId = detectFourWeekPlanId(form)
    if (!fourWeekPlanId) return

    e.preventDefault()
    e.stopImmediatePropagation()

    const variantInput = form.querySelector('[name="id"]')
    const quantityInput = form.querySelector('[name="quantity"]')
    modal.dataset.capturedVariantId = variantInput ? variantInput.value : ''
    modal.dataset.capturedQuantity = quantityInput ? quantityInput.value : '1'
    modal.dataset.capturedFourWeekPlanId = fourWeekPlanId

    modal.show()
  })

  modal
    .querySelector('.recharge-upsell-modal__option--twelve-week')
    .addEventListener('click', function () {
      const twelveWeekPlanId = findTwelveWeekPlanId()
      if (!twelveWeekPlanId) {
        console.error('[recharge-upsell] Could not find 12-week selling plan')
        modal.hide(false)
        return
      }
      const qty =
        Math.max(1, parseInt(modal.dataset.capturedQuantity || '1', 10)) * 3
      addToCart(modal.dataset.capturedVariantId, qty, twelveWeekPlanId, {
        _pdp_recharge_upsell: 'true',
      })
        .then(refreshCart)
        .catch(function (err) {
          console.error('[recharge-upsell]', err)
        })
        .finally(function () {
          modal.hide(false)
        })
    })

  modal
    .querySelector('.recharge-upsell-modal__option--four-week')
    .addEventListener('click', function () {
      addToCart(
        modal.dataset.capturedVariantId,
        parseInt(modal.dataset.capturedQuantity || '1', 10),
        modal.dataset.capturedFourWeekPlanId,
        { _pdp_recharge_upsell: 'false' },
      )
        .then(refreshCart)
        .catch(function (err) {
          console.error('[recharge-upsell]', err)
        })
        .finally(function () {
          modal.hide(false)
        })
    })
})()
